import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=26bfa73a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=26bfa73a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bfa73a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26bfa73a')) {
      api.createRecord('26bfa73a', component.options)
    } else {
      api.reload('26bfa73a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=26bfa73a&scoped=true&", function () {
      api.rerender('26bfa73a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26jlLO5SEQX33/JS/comp/SearchFilterTokens.vue"
export default component.exports